import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { AllocationsUploadResponse } from "@/types/allocations";
import { AlertCircle, Check } from "lucide-react";

interface UploadResultModalProps {
  open: boolean;
  onClose: () => void;
  result?: AllocationsUploadResponse;
}

export const UploadResultModal = ({ open, onClose, result }: UploadResultModalProps) => {
  if (!result) return null;

  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            {result.success ? (
              <>
                <Check className="h-5 w-5 text-emerald-600" />
                Upload Successful
              </>
            ) : (
              <>
                <AlertCircle className="h-5 w-5 text-rose-700" />
                Upload Failed
              </>
            )}
          </DialogTitle>
          <DialogDescription className="sr-only">Upload result details</DialogDescription>
        </DialogHeader>
        <div className="py-4">
          {result.message && <p className="text-muted-foreground mb-4 text-sm">{result.message}</p>}
          {result.processedCount !== undefined && (
            <p className="text-sm">
              <span className="font-medium">Processed:</span> {result.processedCount} record
              {result.processedCount > 1 ? "s" : ""}
            </p>
          )}
          {result.failedCount !== undefined && result.failedCount > 0 && (
            <p className="text-sm text-rose-700">
              <span className="font-medium">Failed:</span> {result.failedCount} record
              {result.failedCount > 1 ? "s" : ""}
            </p>
          )}
          {result.errors && result.errors.length > 0 && (
            <div className="mt-4">
              <p className="mb-2 text-sm font-medium">Errors:</p>
              <ul className="space-y-1 text-sm text-rose-700">
                {result.errors.map((error, index) => (
                  <li key={index} className="flex items-start gap-2">
                    <span className="shrink-0">•</span>
                    <span>{error}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
        <DialogFooter>
          <Button onClick={onClose}>Close</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
